<template>

    <FloatingPanel :title="title" :saveable="false">

        <div class="common-canvas-editor-canvas-document-editors-loop-LoopPanel">

            <button
                    class="tw-my-2 tw-mx-5 hover:tw-bg-blue-400 tw-bg-blue-500 tw-text-sm tw-border-0 tw-font-bold tw-px-4 tw-py-2 tw-rounded tw-text-white tw-mx-2"
                    @click="addItem">
                <i class="fa fa-plus tw-mr-1"></i> Item toevoegen
            </button>

        </div>

    </FloatingPanel>

</template>

<script>

    import FloatingPanel from "../panels/FloatingPanel";
    import AbstractPanel from "../AbstractPanel";

    export default {

        extends: AbstractPanel,

        components: {
            FloatingPanel,
        },

        props: {
            title: {
                type: String,
                default()
                {
                    // Equals this.loopEditorComponent which cannot be computed yet since we are setting up props right now.
                    return (this.$pageComponent().selection.currentSelection.editableData.label || 'Herhaling') + ' bewerken';
                },
            },
        },

        methods: {

            addItem()
            {
                // Add empty to loop items.
                this.loopItems.push({});
            },

        },

        computed: {

			loopItems()
            {
                return this.loopEditorComponent.loopItems;
            },

            loopEditorComponent()
            {
                return this.editorComponent;
            },

        }

    }

</script>

<style lang="scss" scoped>

    .galaxy\:\:common-canvas-editor-canvas-document-editors-loop-LoopPanel {

        @import './../../../../../../../../sass/common/canvas/editor/canvas/document/adminTemplate';

    }

</style>